export default String.raw`
*{
  -webkit-tap-highlight-color: transparent;
  box-sizing:border-box;
  outline:none;
}

h1,
h2,
h3,
h4,
h5,
h6,
p {
  margin: 0;
  padding: 0;
}

h1 {
  @include h1-headline;
}

h2 {
  @include h2-headline;
}

h3 {
  @include h3-headline;
}

h4 {
  @include h4-headline;
}

p {
  @include body-1-regular;
}

html {
  position: relative;
  min-height: 100%;
  font-size:16px;
}

.container {
  width: 93%;
  margin:auto;
}

body {
  margin: 0;
  font-family: $fontFamily, sans-serif;
  background: $bgColor;
  font-weight: 400;
  overflow-y:scroll;
  line-height:1.5em;
  color: $primaryColorFont;
  .docket{
    position: absolute;
    margin-top: 30px;
    color: #717171;
    font-size: 13px;
  }
  @media  screen and (max-width: 1280px) {
    .docket{
      margin-top: 20px;
	    font-size: 11px;
	    line-height: 1.5;
    }
  }
}

img {
  max-width:100%;
}

i {
  color: $iconColors;
  cursor: inherit !important;
}

i:hover {
  cursor: pointer;
}

a {
  color: $iconColors;
  font-weight: 600;
  text-decoration: none;

  svg {
    fill: $iconColors;
  }
}

mark {
  background: $searchPhraseMark;
}

a:hover {
  color: $hoverOverButton;

  svg {
    fill: $hoverOverButton;
  }
}

ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.ulCLassFilterList{
  padding-bottom: 60px;
}

input[type=password]::-ms-reveal,
input[type=password]::-ms-clear {
  display: none;
}

:invalid, :-moz-submit-invalid, :-moz-invalid {
  box-shadow: none;
}

.close-button {
  border: none;
  background: transparent;
  fill: $labelsColor;
  padding: 0;
  cursor: pointer;
  &:hover {
    background: transparent;
    fill: $hoverOverButton;
  }
}

.dropdown-arrow {
  transform: rotate(360);
  transition: transform $animations-time !important;
  display:inline-block;
}

.close-dropdown-js .dropdown-arrow {
  transform:rotate(180deg);
  transition: transform $animations-time;
}

.hidden-js {
  display: none !important;
}

.scroll-container-js {
  overflow-y:auto;
  overflow-x: hidden;
}

.attached-js {
  position:absolute;
  left:0;
  right:0;
}

[readonly] {
  color: #b0b0b0 !important;
  cursor: default;
  pointer-events: none;
  user-select: none;
  border-color: #b0b0b0 !important;
}

input::-ms-clear {
  display: none;
}

h4:first-child {
  margin-top: 0;
}

.expanded-js {
  &.dropdown-arrow, .dropdown-arrow {
    transform:rotate(180deg);
    transition: transform $animations-time !important;
  }
}

.slided-right-js {
  transform:translateX(-100%);
}

.slided-position-right-js {
  left: -110%;
}

.hidden-besides-left-js {
  transform:translateX(-110%) !important;
}

/* waiting for ajax modal */
.during-ajax-modal, .during-ajax-modal-js {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background: $bgColor;
  display: flex;
  opacity: 0.9;
  z-index: 1000;
  .loader {
    margin: auto;
  }
}

.expandable-js {
  height: 0;
  overflow: hidden;
  transition:height $animations-time;
  &.expanded-js {
    height: auto;
  }
  &.no-animation-js{
    transition:none;
  }
}

.product-list {
  position: relative;
}

/* ---- PAGE STRUCTURE ----*/
.page-container {
  position:relative;
}

.main-content {
  width:100%;
  position: relative;
}

.message-popup-background {
  cursor: default;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 10vw;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1001;
  &:not(.hidden-js) + .message-popup-background:not(.unsuccessfull-post-message-js) {
    display: none;
  }
  .popup-container {
    position: relative;
    max-width: 100%;
    width: max-content;
    margin: 0 auto;
    padding: 24px;
    border-radius: 5px;
    box-shadow: 0px 0px 4px 0px $dropContainerShadowColor;
    background-color: $bgColor;
    color: $primaryColorFont;
    transform: translateY(-50%);
    top: 50%;
    left: 0px;
    right: 0px;
    z-index: 999;
    .data-form {
      &__header {
        display: flex;
        justify-content: space-between;
        color: $primaryColorFont;
        font-size: 24px;
        font-weight: 500;
        line-height: 32px;
        margin-bottom: 24px;
        gap: 16px;
      }

      &__info {
        border-bottom: 1px solid #E7E7E7;
        margin-bottom: 24px;
        padding-bottom: 32px;
      }
      .primary-action-button {
        width: 100%;
      }
    }
  }
}

//ADVANCED SEARCH
.seach-by-type-and-area-container {
  display: inline-block;
  width: 590px;
}
//END OF ADVANCED SEARCH

// Social
.social-container {
  width: 93%; 
  margin-top: 32px;
  .CustomerContentSection {
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    .CustomerSocialButton {
      display: inline-flex !important;
      box-shadow: 0px 1px 1px 1px lightgray;
      justify-content: center;
      align-items: center;
      width: calc(10% - 11px);
      min-width: 300px;
      height: 46px;
      color: #232323;
      font-size: 12px;
      line-height: 16px;
      text-transform: uppercase;
      font-weight: 400;
      margin-bottom: 20px;
      padding: 17px;
      text-align: center;
      cursor: pointer;
      letter-spacing: 1px;
    }
    .CustomerSocialButtonGoogle {
      background-color: #FFFFFF;
    }
    .CustomerSocialButtonFacebook {
      background-color: #FFFFFF;
    }
    .CustomerSocialButton:hover {
      box-shadow:0 0 4px #4285F4;
      transition: 1s;
    }
    .GFbLinkIcon {
      margin-right: 10px;
      width: 24px;
      height: 24px;
    }
  }
}

.isInCartPopup {
  position:fixed;
  min-height:40px;
  width:auto;
  padding: 0 20px;
  background-color: $bgColor;
  z-index: 100;
  box-shadow: 2px 2px 3px 0 #b0b0b0;
  color: $primaryColorFont;
  font-size: 15px;
  line-height: 40px;
  border-radius: 8px;
  span {
    color: $iconColors;
  }
  &.isInCart--variants-js {
    margin-top: 5px;
    position: absolute;
    @media screen and (min-width: 1280px) {
      min-width: 270px;
    }
    @media screen and (max-width: 1279px) {
      left: 50%;
      transform: translate(-50%, 0);
    }
  }
}

.svgIcon-inCart {
  width: 20px;
  height: 20px;
  cursor: pointer;
  display: inline-flex;
  vertical-align: middle;
  margin-right: 5px;
  margin-left: 5px;
}

.svgIcon-inCart--PL {
  position: absolute;
  left: 5px;
  top: 50%;
  transform: translate(0, -50%);
}

.successfull-post-message {
  color: $primaryColorFont;
  .message-header {
    text-align: center;
    font-size: 24px;
    font-weight: 500;
    line-height: 32px;
    margin: auto;
    background-color: $bgColor;
    display: flex;
    align-items: center;
    i {
      font-size: 30px !important;
    }
    p {
      color: $primaryColorFont;
      font-size: 18px;
    }
    + .info {
      font-size: 14px !important;
      font-weight: 400 !important;
      line-height: 20px !important;
      padding: 24px 0 24px 0;
      text-align: left !important;
    }
  }
}

button {
  padding: 0;
}

.primary-action-button {
  display: flex;
  text-align: center;
  height: 40px;
  padding: 8px 32px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background-color: $btnSolidBgColor;
  color: $btnSolidTextColor;
  border-radius: 5px;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  cursor: pointer;
  border: none;
  outline: none;
  transition: 200ms;
  
  @media screen and (min-width: 768px) {
    &:hover {
      transition: 200ms;
      background-color: $hoverOverButton;
      color: $btnSolidTextColor;
      svg {
        fill: $btnSolidTextColor;
      }
    }
  }
  @media screen and (max-width: 767px) {
    &:active {
      transition: 200ms;
      background-color: $hoverOverButton;
      color: $btnSolidTextColor;
      svg {
        fill: $btnSolidTextColor;
      }
    }
  }
  &:disabled {
    background-color: #F3F3F3;
    pointer-events: none;
    color: #959595;
    cursor: initial;
    transition: 200ms;  
  }
  svg {
    fill: $btnSolidTextColor;
  }
}

.secondary-action-button {
  display: flex;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: center;
  height: 40px;
  padding: 8px 32px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border: 2px solid $secondaryBtnBorderColor;
  background-color: $secondaryBtnBgColor;
  color: $secondaryBtnFontColor;
  border-radius: 5px;
  cursor: pointer;

  svg {
    fill: $secondaryBtnHoverFontColor;
  }

  @media screen and (min-width: 768px) {
      &:hover {
          transition: 200ms;
          color: $secondaryBtnHoverFontColor;
          border: 2px solid $secondaryBtnHoverBorderColor;
          svg {
            fill: $secondaryBtnHoverFontColor;
          }
      }
  }
  @media screen and (max-width: 767px) {
      &:active {
          transition: 200ms;
          border: 2px solid $secondaryBtnBorderColor;
          background-color: $secondaryBtnBgColor;
          color: $secondaryBtnFontColor;
          svg {
            fill: $secondaryBtnFontColor;
          }
      }
  }
  &:disabled {
    border: 2px solid #959595;
    color: #959595;
    pointer-events: none;
    cursor: initial;
    transition: 200ms;  
  }
}

.pure-button {
  display: flex;
  align-items: center;
  gap: 4px;
  color: $secondaryBtnFontColor;
  background: none;
  border: none;
  cursor: pointer;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  svg {
    fill: $secondaryBtnFontColor;
  }
  &:hover {
    transition: 200ms;
    color: $secondaryBtnHoverFontColor;
    svg {
      fill: $secondaryBtnHoverFontColor;
    }
  } 
}

.contact-validation-error {
  text-align: left;
  color: $dangerColor;
  margin-left: 25px;
}

.error p {
  color: $dangerColor;
}

.small-input-error {
  display: table;
  text-align: left;
  color: $dangerColor;
  font-size: 14px;
  margin-left: 3px;
}

.validation-info__container {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  color: $dangerColor;
  margin: 0 16px 0 16px;

  .svgIcon {
    width: 16px;
    height: 16px;
    fill: $dangerColor;
    margin-right: 4px;
  }

  .validation-info__element {
    display: flex;
    align-items: center;
  }

  .validation-info__container .valid-data-js {
    color: $successColor;
  }

  .valid-data-js .svgIcon {
    fill: $successColor;
  }

  .valid-data-js span {
    color: $successColor;
  }
}

input,
select,
textarea {
  font-family: $fontFamily, sans-serif;
  outline: none;
  background-color: inherit;
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 100px $bgColor inset !important;
    -webkit-text-fill-color: $primaryColorFont !important;
  }
}

select {
  background-image: url("data:image/svg+xml,<svg height='18px' width='18px' viewBox='0 0 448 512' xmlns='http://www.w3.org/2000/svg'><path d='M441.9 167.3l-19.8-19.8c-4.7-4.7-12.3-4.7-17 0L224 328.2 42.9 147.5c-4.7-4.7-12.3-4.7-17 0L6.1 167.3c-4.7 4.7-4.7 12.3 0 17l209.4 209.4c4.7 4.7 12.3 4.7 17 0l209.4-209.4c4.7-4.7 4.7-12.3 0-17z'/></svg>");
  background-repeat: no-repeat;
  background-position-x: 95%;
  background-position-y: 50%;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  padding-right: 30px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  cursor: pointer;
}

.number-input {
  width: 60px !important;
  padding: 0 4px 0 14px !important;
}

textarea {
  width: 100%;
  height: 96px;
  background-color: inherit;
  color: $primaryColorFont;
  padding: 18px 16px 24px !important;
  border-radius: 5px;
  border: 1px solid $inputsBorderColor;
  font-size: 15px;
  resize: vertical;
  max-height: 300px;
  min-height: 96px;
  
  &::placeholder {
    color: $labelsColor;
    font-size: 14px;
    line-height: 20px;
  }
}

.characters-length {
  margin: -6px 0 0 24px;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #5b5858;
  text-align: left;
  position: relative;
}

.form {
  input {
    border: none;
    outline: none;
    border-bottom: 1px solid $inputsBgColor;
    font-size: 14px;
    color: $inputsBgColor;
    width: 100%;
    box-sizing: border-box;
    padding: 10px 0;
    margin-bottom: 10px;
    transition: all 1s ease; 

    &::placeholder {
      color: $labelsColor;
    }
  }
  &-container {
    background-color: $bgColor;
    width: 30rem;
    min-height: auto;
    padding: 2rem 3rem;
    box-sizing: border-box;
    .primary-action-button {
      width: 100%;
      height: 50px;
      justify-content: center;
    }
  }
  &__header {
    color: $primaryColorFont;
    opacity: 0.65;
    text-align: center;
    margin-bottom: 20px;
    font-weight: normal;
  }
  &__required-fields {
    margin: 8px 0 24px;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: #5b5858;
    text-align: left;
  }
  &__wrapper {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    & > .form__input-wrapper {
      width: 49%;
    }
    &.first-short > .form__input-wrapper {
      width: 69%;
      &:first-child {
        width: 29%;
      }
    }
  }
  &__input {
    &-wrapper {
      padding: 0 1px;
      display: block;
      position: relative;
      width: 100%;
      background-color: inherit;
      margin-bottom: 24px;

      &:focus-within label {
        color: $iconColors;
      }

      label {
        color: $labelsColor;
        position: absolute;
        left: 16px;
        top: 50%;
        transform: translateY(-50%);
        pointer-events: none;
        transition: 0.2s ease all;
        font-size: 14px;
      }

      > label, > .form__input-info {
        color: $labelsColor;
      }


      .form__input-value:disabled + label {
        color: $labelsColor;
      }

      .validation-error {
        color: $dangerColor !important;
      }

      &.textarea {
        .form__invalid-input {
          margin: -10px 0;
        }
      }
    }

    &-value {
      width: 100%;
      padding: 6px 16px;
      background-color: inherit;
      color: $primaryColorFont;
      border: 1px solid $inputsBorderColor;
      border-radius: 5px;
      height: 40px;
      box-sizing: border-box;

      &:hover {
        border-color: $inputsHoverColor;
      }
      &:focus {
        border-color: $iconColors;
        box-shadow: 0 0 0 1px $iconColors;
        transition: 0.3s all;
      }
      &:disabled {
        border-color: $labelsColor;
      }

      .select {
        &__options {
          left: 0;
          top: 40px;
        }
      }

      &--clear-button {
        display: none;
        position: absolute;
        top: 10px;
        right: 5px;
        padding-left: 5px;
        background: white;
        cursor: pointer;
        svg {
          fill: $primaryColor;
          width: 20px !important;
          height: 20px !important;
        }
      }
      &.has-value + .form__input-value--clear-button {
        display: block;

      }
    }
    
    &-info {
      left: 16px;
      position: absolute;
      pointer-events: none;
      padding: 0 4px;
      background-color: $bgColor;
      transition: 0.2s ease all;
      top: 50%;
      transform: translateY(-50%);
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      z-index: 1;
      &.disabled {
        top: 1px;
        font-size: 12px;
        line-height: 16px;
        padding: 0 4px;
        z-index: 100;
      }
    }
  }

  &__validation-info-js,
  &__validation-tin-js,
  &__validation-required-js,
  &__invalid-input {
    color: $dangerColor;
    font-size: 12px;
    display: block;
    position: absolute;
    margin: -3px 0;

    &.validation-zip-code-js {
      position: static;
    }
  }
  
  &__icons {
    color: $labelsColor;
    position: absolute;
    left: 0;
  }

  .form__icon,
  &__icon {
    &_left {
      left: 2.5rem;
    }
    &_padding {
      padding-left: 2.5rem;
    }
  }

  &__textarea {
    &_height {
      top: 125px !important;
    }
  }

  &__preview {
    left: auto;
    top: 0.5rem;
    right: 0.5rem;
    cursor: pointer;
    color: $labelsColor;
    fill: $labelsColor;

    .svgIcon {
      width: 24px;
      height: 24px;
    }
  }

  &__requiredFields--info {
    color: #4b4848;
    font-size: 12px;
  }

  > button {
    width: 100%;
    margin: 15px 0;
  }
}

.checkBoxes__container input {
  display: none;

  &[disabled] + label::before {
    opacity: 0.7;
    user-select: none;
  }

  &[disabled] + label {
      pointer-events: none;
      opacity: 0.7;
  }
}

.checkBoxes__container input+label {
  display: flex;
  align-items: baseline;
  column-gap: 0.8em;
  cursor: pointer;
  position: relative;
  background-color: transparent;
  color: $primaryColorFont;
  transition: all 200ms ease;
}

.checkBoxes__container label {
  &:hover {
    &::before {
      border: solid 1px #7C3033;
    }
  }
}

.checkBoxes__container input+label:before {
  content: "";
  display: inline-block;
  min-width: 16px;
  width: 16px;
  height: 16px;
  border-radius: 4px;
  border: solid 1px $lightBorderColor;
  transform: translateY(0.25em);
  background-color: $standardCheckboxBg;
  box-sizing: border-box;
  transition: all 200ms ease;

  &:hover {
    border: solid 1px $standardCheckboxActiveBg;
  }
}

.checkBoxes__container input+label .checkBoxes__checkIcon {
  display: none;
}

.checkBoxes__container input:checked+label .checkBoxes__checkIcon {
  display: block;
  position: absolute;
  left: 2px;
  top: -2px;
  transform: translateY(0.25em);
}

.checkBoxes__container input+label .checkBoxes__checkIcon svg {
  fill: $standardCheckboxBg;
  width: 12px;
  height: 12px;
}

.checkBoxes__container label.validation-error-js:before {
  border: 1px solid $dangerColor !important;
}

.checkBoxes__container input:checked+label:before {
  content: "";
  text-align: center;
  background-color: $standardCheckboxActiveBg;
  overflow: hidden;
  border: solid 1px $standardCheckboxActiveBg;
}

.checkBoxes__container--radio {
  input+label .checkBoxes__checkIcon svg{
    fill: $standardCheckboxActiveBg;
  }

  input+label:before {
      border-radius: 50%;
  }

  input:checked+label:before {
    background-color: $standardCheckboxBg;
  }
}

.button {
  &__icon {
    display: flex;
    width: 24px;
    height: 24px;
    justify-content: center;
    align-items: center;
  }

  &__group {
    display: flex;
    flex-direction: row;
    width: 100%;
    flex-wrap: nowrap;
    gap: 8px;

    .primary-action-button {
      flex-grow: 1;
    }

    .secondary-action-button {
      flex-shrink: 0;
      flex-grow: unset;
      height: 40px;
      width: 40px;
      padding: 8px;
    }
  }
}

.connected {
    gap: 0;

    >.button:first-child {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }

    >.button:last-child {
        border-left: none;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }
}

.page-padding {
  padding: 0 9%;
}

@media only screen and (max-width: 1439px) {
  .page-padding {
    padding: 0 32px;
  }
}

@media only screen and (max-width: 767px) {
  .page-padding {
    padding: 0 5%;
  }
}

.required-fields {
  margin: 8px 0 24px 0;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #5b5858;
  text-align: left;
}

.arrow {
  display: flex;
  width: 48px;
  height: 48px;
  max-width: 48px;
  max-height: 48px;
  box-sizing: border-box;
  aspect-ratio: 1/1;
  background: $bgColor;
  border-radius: 4px;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: none;

  &__icon {
      fill: $btnSolidBgColor;
  }

  &.shadowed {
      box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);
  }
  
  &.small {
      width: 24px;
      height: 24px;
      max-width: 24px;
      max-height: 24px;
  }
}

.swiper-button-disabled {
  display: none !important;
}

.characters-counter-js {
  position: relative;
  bottom: 23px;
  right: -12px;
  font-size: 12px;
  color: #666;
  opacity: 0;
  transition: opacity 0.2s;
  height: 16px;
  background: #fff;
  display: flex;
  width: calc(100% - 35px);
  align-items: center;
  justify-content: flex-end;
}

.scrollable {
  position: absolute;
  top: 1px;
  right: 24px;
  height: 16px;
  background: #fff;
  display: flex;
  width: calc(100% - 35px);
  align-items: center;
  justify-content: flex-end;
}

.characters-counter-js:not(.hidden-js) {
  opacity: 1;
}

::-webkit-scrollbar {
  height: 4px;
  width: 4px;
  border-radius: 2.5px;
  opacity: 49%;
}
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 4px transparent;
  opacity: 17%;
}
::-webkit-scrollbar-thumb {
  background-color: rgba(#959595, 0.5);
  outline: none;
  border-radius: 2px;
  &:hover{
      background-color: #959595;
  }
}

.ai-generated-content {
  @include body-2-regular;
  color: #727272;
}

[name=quantity] {
    display: block;
    float: left;
    line-height: 1.5em;
    height: 40px;
    width: 40px;
    text-align: center;
    border: 1px solid #DDDDDD;
    padding: 0
}

.archival {
    background: #D5D5D5;
}

.Promotion,.Free {
    background: $ribbonPromotion;
}

.BestRated {
    background: $ribbonBestRated;
}

.NewProduct {
    background: $ribbonNewProduct;
}

.PromotionalProduct {
    background: $ribbonPromotionalProduct;
}

.RecommendedProduct {
    background: $ribbonRecommendedProduct;
}

.VendorRecomendation {
    background: $ribbonVendorRecomendation;
}

.GreatPrice {
    background: $ribbonGreatPrice;
}

.GreatQuality {
    background: $ribbonGreatQuality;
}

.Sale {
    background: $ribbonSale;
}

.Reward {
    background: $ribbonReward;
}

.quantity-flag {
    background: $primaryColor;
    color: $lightestColorFont;
}
`